import { render, staticRenderFns } from "./WaitingForData.vue?vue&type=template&id=3fad91f1&scoped=true&"
import script from "./WaitingForData.vue?vue&type=script&lang=js&"
export * from "./WaitingForData.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForData.vue?vue&type=style&index=0&id=3fad91f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad91f1",
  null
  
)

export default component.exports